import { render } from "./SeccionComentarios.vue?vue&type=template&id=bf0af694&scoped=true&ts=true"
import script from "./SeccionComentarios.vue?vue&type=script&lang=ts"
export * from "./SeccionComentarios.vue?vue&type=script&lang=ts"

import "./SeccionComentarios.vue?vue&type=style&index=0&id=bf0af694&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\4\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0af694"]])

export default __exports__